export { MainBannerSection } from './main-banner';
export { PartnersSection } from './partners';
export { StepsSection } from './steps';
export { WorksSection } from './works';
export { default as SpecialtyMobileSection } from './specialty/specialty-mobile';
export { default as SpecialtySection } from './specialty/specialty';
